import React, { useState } from 'react';
import './Contact.css';

const PhoneIcon = () => (
  <svg className="contact-svg-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.79 19.79 0 0 1 2.12 4.18 2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
  </svg>
);

const MessageIcon = () => (
  <svg className="contact-svg-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
    <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" />
  </svg>
);

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    alert('Thank you for your inquiry! We will contact you soon.');
    setFormData({ name: '', email: '', phone: '', message: '' });
  };

  const tradingHours = [
    { day: 'Monday', time: '08:00 – 17:00' },
    { day: 'Tuesday', time: '08:00 – 17:00' },
    { day: 'Wednesday', time: '08:00 – 17:00' },
    { day: 'Thursday', time: '08:00 – 17:00' },
    { day: 'Friday', time: '08:00 – 16:00' },
    { day: 'Saturday', time: '08:00 – 12:00' },
    { day: 'Sunday', time: 'Closed' }
  ];

  return (
    <section id="contact" className="contact section">
      <div className="container">
        <h2 className="section-title animate-fade-in-up">Trading Hours & Contact</h2>
        
        <div className="contact-content">
          {/* Contact Information */}
          <div className="contact-info">
            <div className="contact-item animate-fade-in-left">
              <div className="contact-icon" aria-label="Phone">
                <PhoneIcon />
              </div>
              <div className="contact-details">
                <h4>Phone</h4>
                <p>012 321 0060</p>
              </div>
            </div>
            
            <div className="contact-item animate-fade-in-left" style={{ animationDelay: '0.1s' }}>
              <div className="contact-icon"></div>
              <div className="contact-details">
                <h4>Email</h4>
                <p>sales@totalguardppe.co.za</p>
              </div>
            </div>

            <div className="contact-item animate-fade-in-left" style={{ animationDelay: '0.15s' }}>
              <div className="contact-icon" aria-label="WhatsApp">
                <MessageIcon />
              </div>
              <div className="contact-details">
                <h4>WhatsApp</h4>
                <p>061 677 9840</p>
              </div>
            </div>
            
            <div className="contact-item animate-fade-in-left" style={{ animationDelay: '0.2s' }}>
              <div className="contact-icon"></div>
              <div className="contact-details">
                <h4>Company</h4>
                <p>Totalguard Workwear Rosslyn</p>
              </div>
            </div>
            
            {/* Trading Hours */}
            <div className="hours-table animate-fade-in-left" style={{ animationDelay: '0.3s' }}>
              <h4>Trading Hours</h4>
              {tradingHours.map((item, index) => (
                <div key={index} className="hours-row">
                  <span className="hours-day">{item.day}</span>
                  <span className="hours-time">{item.time}</span>
                </div>
              ))}
            </div>
          </div>
          
          {/* Contact Form */}
          <div className="contact-form animate-fade-in-right">
            <h3>Enquire About PPE Solutions</h3>
            <p>Get in touch with us for a quote or to discuss your PPE requirements.</p>
            
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="name">Name *</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  placeholder="Enter your full name"
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="email">Email *</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  placeholder="Enter your email address"
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="phone">Phone</label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder="Enter your phone number"
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="message">Message *</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  placeholder="Tell us about your PPE requirements..."
                ></textarea>
              </div>
              
              <button type="submit" className="btn">
                Send Inquiry
              </button>
            </form>
            
            <div className="form-note">
              <p>Or call us directly at <strong>012 321 0060</strong> for immediate assistance.</p>
            </div>
          </div>
        </div>
        
        <div className="contact-cta animate-fade-in-up" style={{ animationDelay: '0.4s' }}>
          <h3>Ready to Experience the Totalguard Workwear Rosslyn Difference?</h3>
          <p>Visit us today and discover why businesses across industries trust Totalguard Workwear Rosslyn for their PPE solutions. Our expert team is ready to help you find the perfect protective equipment for your needs.</p>
        </div>
      </div>
    </section>
  );
};

export default Contact;
